import React, { useEffect, useState } from 'react';
import "../styles/ForgotPasswordPage.css";
import { FaEye, FaEyeSlash, FaLock } from 'react-icons/fa';
import axios from 'axios';
import { GridLoader } from 'react-spinners';
import { useNavigate } from 'react-router-dom';

function ForgotPassword() {

  const navigate = useNavigate();
  const [entered_email, setEntered_email] = useState('');
  const [employee_id, setEmployee_id] = useState('');
  const [message, setMessage] = useState('');
  const [otpError, setOtpError] = useState({ otp: '', employee_id: '' });
  const baseURL = sessionStorage.getItem('baseURL');

  useEffect(() => {
    hideAll();
    showDiv('fetchEmail');
  }, []);

  const navigateToDashboard = () => {
    navigate('/');
  };

  const hideAll = () => {
    document.getElementById('fetchEmail').hidden = true;
    document.getElementById('loading').hidden = true;
  };

  const showDiv = (id) => {
    document.getElementById(id).hidden = false;
  };

  function showToast(message, type = "success") {
    const toast = document.createElement("div");
    toast.innerText = message;
    Object.assign(toast.style, {
      position: "fixed",
      top: "20px",
      right: "20px",
      background: type === "error" ? "#d32f2f" : type === "success" ? "#2e7d32" : "#ffa000",
      color: "#fff",
      padding: "12px 18px",
      borderRadius: "6px",
      boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
      zIndex: 9999,
      opacity: "0",
      transition: "opacity 0.3s ease",
      fontFamily: "'Source Sans 3', sans-serif",
      fontSize: ".9rem",
    });
    document.body.appendChild(toast);
    requestAnimationFrame(() => (toast.style.opacity = "1"));
    setTimeout(() => {
      toast.style.opacity = "0";
      setTimeout(() => toast.remove(), 300);
    }, 3500);
  }

  const validateForm = () => {
    let isValid = true;
    if (entered_email.trim() === '') {
      setOtpError((prev) => ({ ...prev, otp: 'Email is required' }));
      isValid = false;
    }
    if (employee_id.trim() === '') {
      setOtpError((prev) => ({ ...prev, employee_id: 'Employee ID is required' }));
      isValid = false;
    }
    return isValid;
  };

  const handleSubmit = () => {
    if (!validateForm()) return;

    showDiv('loading');
    axios.post(baseURL + 'auth/forgotPassword', {
      email: entered_email,
      employee_id: employee_id.toLowerCase(),
    })
      .then(() => {
        showToast("Password Reset Link Sent");
        hideAll();
        navigate('/');
      })
      .catch((error) => {
        showToast("Error sending password reset", "error");
        setMessage((error.response?.data?.message ?? "An error occurred.") + " Please Check.");
        hideAll();
        showDiv('fetchEmail');
      });
  };

  return (
    <div>
      {/* Sub-header nav bar */}
      <div className="dashboard-header">
        <button onClick={navigateToDashboard} className="action-button">
          ← Home
        </button>
      </div>

      <div className="forgot-password-container">

        {/* Main form */}
        <form id="fetchEmail">
          <label htmlFor="employee-id">Employee ID</label>
          <input
            id="employee-id"
            type="text"
            value={employee_id}
            placeholder="Enter your Employee ID"
            onChange={(e) => {
              setEmployee_id(e.target.value);
              setOtpError((prev) => ({ ...prev, employee_id: '' }));
            }}
          />
          {otpError.employee_id && (
            <div className="error-message">{otpError.employee_id}</div>
          )}

          <label htmlFor="email-id">Email ID</label>
          <input
            id="email-id"
            type="text"
            value={entered_email}
            placeholder="Enter your Email ID"
            onChange={(e) => {
              setEntered_email(e.target.value);
              setOtpError((prev) => ({ ...prev, otp: '' }));
            }}
          />
          {otpError.otp && (
            <div className="error-message">{otpError.otp}</div>
          )}

          <button type="button" onClick={handleSubmit}>
            Reset Password
          </button>

          {message && <div className="error-message">{message}</div>}
        </form>

        {/* Loading spinner — Cadila navy */}
        <div className="loading" id="loading">
          <GridLoader color="#2C3493" loading={true} size={20} />
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;